












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Picture extends Vue {
  @Prop({ type: String, default: '' })
  readonly src!: string;

  @Prop({ type: String, default: '' })
  readonly alt!: string;

  @Prop({ type: Boolean, default: false })
  readonly finished!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly copp!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/components/picture/Picture.vue